import { useState } from 'react';

import { Group, Stack } from '@mantine/core';
import type { FileWithPath } from '@mantine/dropzone';

import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button } from '../../../../../../../../shared/components/UI/Button/Button';

import { BuyerSimResponseDocType } from '../../../../../../../../shared/entities/BuyerSimBidResponse';
import {
  BlueHighlight,
  DropzoneLabel,
} from '../../../buyerSimulationList/BuyerSimDropzoneLabel';
import { DropZoneInput } from '../../../buyerSimulationList/DropZoneInput';
import { useBuyerSimBidResponse } from '../../hooks/useBuyerSimBidResponse.hook';
import { useCreateBuyerSimProposalVersion } from './useCreateBuyerSimProposalVersion.hook';

type BuyerSimVersionInputsProps = {
  buyerSimBidResponseId: number;
  setSelectedProposalVersion: (buyerSimProposalVersionId: number) => void;
};
export const BuyerSimVersionInputs = ({
  buyerSimBidResponseId,
  setSelectedProposalVersion,
}: BuyerSimVersionInputsProps) => {
  const { refetchBuyerSimBidResponse } = useBuyerSimBidResponse(
    buyerSimBidResponseId,
  );
  const { createBuyerSimProposalVersion } = useCreateBuyerSimProposalVersion();
  const navigate = useNavigate();
  const [proposalFiles, setProposalFiles] = useState<FileWithPath[]>([]);
  const [complementaryFiles, setComplementaryFiles] = useState<FileWithPath[]>(
    [],
  );

  const handleDrop = (
    newFile: FileWithPath[],
    type: BuyerSimResponseDocType,
  ) => {
    if (type === BuyerSimResponseDocType.PROPOSAL_TECHNICAL_SUBMISSION) {
      setProposalFiles(prev => [...prev, ...newFile]);
    } else {
      setComplementaryFiles(prev => [...prev, ...newFile]);
    }
  };

  const createNewBuyerSimProposalVersion = () => {
    createBuyerSimProposalVersion({
      buyerSimBidResponseId,
      proposalFiles,
      complementaryFiles,
      onSuccessCallback: data => {
        refetchBuyerSimBidResponse();
        setSelectedProposalVersion(data.id);
        navigate(
          `/response/simulation/${buyerSimBidResponseId}?tab=buyerSimulation`,
        );
      },
    });
  };

  const criteriaDropzoneLabel = (
    <Trans
      ns="buyerSimulation"
      i18nKey="buyerSimVersionInputs.dropzone.memTechLabel"
      components={{ highlight: <BlueHighlight /> }}
    />
  );

  const appendixDropzoneLabel = (
    <Trans
      ns="buyerSimulation"
      i18nKey="buyerSimVersionInputs.dropzone.appendixLabel"
      components={{ highlight: <BlueHighlight /> }}
    />
  );
  return (
    <Stack spacing="05">
      <Group noWrap spacing="02" align="flex-end" miw="960px">
        <DropZoneInput
          files={[]}
          onFileChange={files =>
            handleDrop(
              files,
              BuyerSimResponseDocType.PROPOSAL_TECHNICAL_SUBMISSION,
            )
          }
          label="Chargez une version de votre réponse"
        >
          <DropzoneLabel
            label={criteriaDropzoneLabel}
            inputHasFiles={proposalFiles.length > 0}
            isMandatory
          />
        </DropZoneInput>
        <DropZoneInput
          files={[]}
          onFileChange={files =>
            handleDrop(files, BuyerSimResponseDocType.PROPOSAL_APPENDICES)
          }
        >
          <DropzoneLabel
            label={appendixDropzoneLabel}
            inputHasFiles={complementaryFiles.length > 0}
          />
        </DropZoneInput>
      </Group>
      <Button
        w="fit-content"
        disabled={!proposalFiles.length}
        onClick={createNewBuyerSimProposalVersion}
      >
        Lancer la simulation acheteur
      </Button>
    </Stack>
  );
};
